/**
 * Modal
 *
 * @selector .modal
 * @enabled true
 */

import * as focusTrap from 'focus-trap';
import BaseModule from '../../modules/BaseModule.js';

export default class Modal extends BaseModule {
    init(element) {
        this.el = element;
        this.$el = $(this.el);

        this.isOpen = false;
        const autoOpen = this.el.dataset.autoOpen;
        this.el.setAttribute('inert', '');

        this.focusTrap = focusTrap.createFocusTrap([this.el, '#onetrust-consent-sdk'], {
            fallbackFocus: this.el,
        });

        window.addEventListener('hashchange', (event) => {
            if (window.location.hash.substring(1) === this.el.id && !this.isOpen) {
                this.$el.modal('show');
            } else if (!window.location.hash.substring(1) === this.el.id && this.isOpen) {
                this.$el.modal('hide');
            }
        });

        this.el.addEventListener('keydown', (event) => {
            // because the native bootstrap escape handling will not stop propagation and trigger other events...
            if (event.key === 'Escape') {
                event.stopPropagation();
                this.$el.modal('hide');
            }
        });

        if (window.location.hash.includes(this.el.id) || autoOpen) {
            setTimeout(() => {
                this.$el.modal('show');
            }, 0);
        }

        this.$el.on('shown.bs.modal', (event) => {
            this.isOpen = true;
            window.location.hash = this.el.id;
            this.el.removeAttribute('inert');
            this.focusTrap.activate();
        });

        this.$el.on('hidden.bs.modal', (event) => {
            this.isOpen = false;
            const [url, hash] = window.location.href.split('#');
            window.history.pushState(null, null, url);
            this.el.setAttribute('inert', '');
            this.focusTrap.deactivate();
        });

        return this;
    }
}
